import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=4b5a4c84&scoped=true&"
import script from "./QuestionForm.vue?vue&type=script&lang=js&"
export * from "./QuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&id=4b5a4c84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a4c84",
  null
  
)

export default component.exports